import React, { useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import Departamentos from "../../../src/assets/data/departamentos.json";
import Ciudades from "../../../src/assets/data/ciudades.json";
import { tiposDeDocumento, formaPago, metodoPago } from "../../assets/data/arrays";
import CotizacionForm from "../forms/CotizacionForm";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const CreateCotizacion: React.FC = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null); // Reservado para uso futuro
  const [responseData, setResponseData] = useState<any>(null);

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.error("No hay token disponible en localStorage");
        toast.error("Error de autenticación", { icon: "⚠️", position: 'top-center' });
        return;
      }

      console.log('Datos a enviar al crear cotización:', data);
      setResponseData(data);

      const response = await axiosInstance.post("/cotizacion", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // Obtener el ID de la cotización creada desde la respuesta
      const cotizacionId = response.data?.id || 
                          response.data?.cotizaciones_id || 
                          response.data?.data?.id || 
                          response.data?.data?.cotizaciones_id;

      if (cotizacionId) {
        toast.success(`Cotización creada exitosamente #${cotizacionId}`, { icon: "✅", position: 'top-center' });
        // Redirigir a la página de edición con el nuevo ID para que recargue con los datos
        navigate(`/cotizaciones/${cotizacionId}/edit`);
      } else {
        toast.success("Cotización creada exitosamente ✅", { icon: "✅", position: 'top-center' });
        navigate('/cotizaciones');
      }
    } catch (error) {
      console.error("Error al crear la cotización:", error);
      toast.error("Error al crear la cotización", { icon: "⚠️", position: 'top-center' });
    }
  };

  return (
    <div className="px-4 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-4">
          <button 
            onClick={() => navigate('/cotizacion')}
            className="text-blue-800 hover:text-blue-900 transition-colors">
          </button>
          <h1 className="text-2xl font-semibold text-blue-800">
            {/* Crear Nueva Cotización */}
          </h1>
        </div>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-red-600">{error}</p>
        </div>
      )}

      <CotizacionForm 
        mode="create"
        onSubmit={handleSubmit}
        tiposDeDocumento={tiposDeDocumento}
        departamentos={Departamentos}
        ciudades={Ciudades}
        formaPago={formaPago}
        metodoPago={metodoPago}/>

      {responseData && (
        <div className="mt-8 p-4 bg-white rounded-lg shadow">
        </div>
      )}
    </div>
  );
};

export default CreateCotizacion; 